/** @jsx isolateComponent */

import { Fragment } from 'react';

import { isolateComponent } from '@zapier/common-utils';
import { Link, Spacer, Text } from '@zapier/design-system';

import {
  Currency,
  Interval,
  PlanType,
  Price,
} from '@zapier/design-system-revenue';

type Props = {
  currency: Currency | undefined;
  interval: Interval;
  monthlyAmount: number;
  planType: PlanType;
  tasks: number;
};

const adverbify = (interval: Interval) =>
  interval === 'year' ? 'annually' : 'monthly';

const pluralize = (planType: PlanType) =>
  planType === 'Team' ? 'Teams' : 'Companies';

export const ReducedTaskTeamCompanyActiveOfferBannerView = ({
  currency,
  interval,
  monthlyAmount,
  planType,
  tasks,
}: Props) => (
  <Fragment>
    <Text tag="h3" textAlign="center" type="subtitle900">
      You're on Zapier for {pluralize(planType)} (
      {Number(tasks).toLocaleString()} Tasks)
    </Text>

    <Spacer height={5} />

    <div style={{ margin: '0 auto', maxWidth: '650px' }}>
      <Text
        color="grey700"
        fontWeight={600}
        tag="p"
        textAlign="center"
        type="subtitle800"
      >
        Stay on this custom {planType} plan for{' '}
        <Price currency={currency}>{monthlyAmount}</Price>/month (paid{' '}
        {adverbify(interval)}) or switch to one of our existing plans below.{' '}
        <Link href="/app/settings/billing">View billing info</Link>
      </Text>
    </div>
  </Fragment>
);
